import React, { Fragment, useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ApplicationState } from "../../store";
import { DialogComponent } from "../common/DialogComponent";
import EZSCreditAuthentication from "../Credit/Auth/EZSCreditAuthentication";
import { ICSIDUserStatus } from "../../store/csid/types";
import * as CSIDActions from "../../store/csid/actions";
import * as NextStepFlowAction from "../../store/nextStepFlowService/actions";

const ActiveCreditMonitoring = (props: any) => {
    const dispatch = useDispatch();
    const csidUserStatus = useSelector((state: ApplicationState) =>
        state.csidUserStatusState && state.csidUserStatusState.csidUserStatus ? state.csidUserStatusState.csidUserStatus : {}
    );
    const getUserCSIDStatus = () => dispatch(CSIDActions.actionCreators.getUserCSIDStatus());
    const requestNextStepFlow = () => dispatch(NextStepFlowAction.actionCreators.requestNextStepFlow());
    const [showCreditAuth, setShowCreditAuth] = useState(false);
    const refreshContext = () => dispatch(CSIDActions.actionCreators.componentNeedsRefresh());

    useEffect(() => {
        getUserCSIDStatus();
    }, []);

    const closeDisclosureDialogCallBack = (callbackObj: any) => {
        setShowCreditAuth(false);
        getUserCSIDStatus();
    };

    const ezsCreditAuthSuccessCallBack = (callbackObj: any) => {
        setShowCreditAuth(false);
        requestNextStepFlow();
        refreshContext();
    };

    const openSSNAuthClick = () => {
        setShowCreditAuth(true);
    };

    return (
        <Fragment>
            <li>
                <div className="dashboard-alert-container status-alert" onClick={() => openSSNAuthClick()}>
                    <a style={{ cursor: "pointer" }}>
                        <span className="row">
                            <span className="col-xs col-no-gutter flex-grow-null">
                                <span className="dashboard-alert-icon">
                                    <em className="las la-exclamation-triangle"></em>
                                </span>
                            </span>
                            <span className="col-xs col-no-gutter">
                                <span className="dashboard-alert-description">
                                    <span className="sr-only">Critical Alert</span> {props.flowStepName}
                                </span>
                            </span>
                        </span>
                    </a>
                </div>
            </li>
            <>
                {showCreditAuth && csidUserStatus && (
                    <DialogComponent dialogId="dialog-ssn-disclosure" title="SSN Disclosure" closeDialog={closeDisclosureDialogCallBack} hideCloseButton={false}>
                        <div className="dialog-body">
                            <EZSCreditAuthentication
                                initCSIDUserStatus={csidUserStatus as ICSIDUserStatus}
                                creditAuthCallback={ezsCreditAuthSuccessCallBack}
                                displayFlowAsDialog={false}
                                onCloseCallback={closeDisclosureDialogCallBack}
                                l3Case={"credit-service"}
                                continueFlowWithL3={false}
                            />
                        </div>
                    </DialogComponent>
                )}
            </>
        </Fragment>
    );
};

export default ActiveCreditMonitoring;
